var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getloading)?_c('div',{staticClass:"loading-page"},[_c('loading',{staticClass:"loading-color",attrs:{"active":_vm.getloading,"can-cancel":false,"is-full-page":true,"color":'#46B090'}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }